export default __webpack_public_path__ + "static/discord-b1f762ef2042b0461423f356184b8624.png";